import { BankingPartner } from '../enums/banking-partner.enum';
import { PaymentType } from '../enums/payment-type.enum';
import { IDelay } from './delay.interface';

export interface IClearing {
  delay?: IDelay[];
  accountUid: string;
  bankingPartner: BankingPartner;
  clearingDelay?: boolean;
  // Derived fields
  paymentType?: PaymentType[];
  commonDelay?: string;
}
